import { MeetingLayout } from "../types";

export const createMeetingURL = (
    baseURL: string,
    meetingId: string,
    userId: string,
    joinCode?: string,
    layout?: MeetingLayout | "training",
    via?: string,
): string => {

    const url = new URL(`${baseURL}/meeting`);

    url.searchParams.append("meetingId", meetingId);
    url.searchParams.append("userId", userId);

    if (joinCode) {
        url.searchParams.append("joinCode", joinCode)
    }

    if (layout) {
        url.searchParams.append("layout", layout);
    }

    if (via) {
        url.searchParams.append("via", via);
    }

    return url.toString();
};